import React, { forwardRef } from 'react';
import classnames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Input_inputContainer_2ifq9HK1IT{display:flex;width:100%;transition:box-shadow .1s ease-out;border-radius:var(--radius,3px);background:var(--background,#fff);color:var(--foreground,#2d2d2d)}.Input_inputContainer_2ifq9HK1IT,.Input_inputContainer_2ifq9HK1IT *{box-sizing:border-box}.Input_inputContainer_2ifq9HK1IT.Input_hasFocus_1KUDRIxW17{box-shadow:0 0 0 4px var(--focus,rgba(96,150,230,.75))}.Input_inputContainer_2ifq9HK1IT.Input_hasFocus_1KUDRIxW17 .Input_afterInput_21VUtLIisX,.Input_inputContainer_2ifq9HK1IT.Input_hasFocus_1KUDRIxW17 .Input_beforeInput_3XRl-X8Tip{border-color:var(--secondary-base,#0a7c8e)}.Input_inputContainer_2ifq9HK1IT .Input_afterInput_21VUtLIisX,.Input_inputContainer_2ifq9HK1IT .Input_beforeInput_3XRl-X8Tip{display:inline-flex;padding:8px;border:1px solid var(--neutral-light,#d5d9de);border-radius:var(--radius,3px) 0 0 var(--radius,3px);align-items:center}.Input_inputContainer_2ifq9HK1IT .Input_afterInput_21VUtLIisX{border-radius:0 var(--radius,3px) var(--radius,3px) 0}.Input_inputContainer_2ifq9HK1IT.Input_invalid_3dXOb-nrkb .Input_afterInput_21VUtLIisX,.Input_inputContainer_2ifq9HK1IT.Input_invalid_3dXOb-nrkb .Input_beforeInput_3XRl-X8Tip{border-top-color:var(--error-base,#d10f0f);border-bottom-color:var(--error-base,#d10f0f)}.Input_inputContainer_2ifq9HK1IT.Input_invalid_3dXOb-nrkb .Input_beforeInput_3XRl-X8Tip{border-left-color:var(--error-base,#d10f0f)}.Input_inputContainer_2ifq9HK1IT.Input_invalid_3dXOb-nrkb .Input_afterInput_21VUtLIisX{border-right-color:var(--error-base,#d10f0f)}.Input_inputContainer_2ifq9HK1IT[data-disabled=true] .Input_afterInput_21VUtLIisX,.Input_inputContainer_2ifq9HK1IT[data-disabled=true] .Input_beforeInput_3XRl-X8Tip{cursor:not-allowed;background:var(--neutral-light,#d5d9de);border-color:var(--neutral-light,#d5d9de);color:var(--neutral-dark,#a0a5ab)}.Input_inputContainer_2ifq9HK1IT[data-disabled=true] .Input_afterInput_21VUtLIisX g:not([fill~=\"#\"]),.Input_inputContainer_2ifq9HK1IT[data-disabled=true] .Input_afterInput_21VUtLIisX path:not([fill~=\"#\"]),.Input_inputContainer_2ifq9HK1IT[data-disabled=true] .Input_afterInput_21VUtLIisX use:not([fill~=\"#\"]),.Input_inputContainer_2ifq9HK1IT[data-disabled=true] .Input_beforeInput_3XRl-X8Tip g:not([fill~=\"#\"]),.Input_inputContainer_2ifq9HK1IT[data-disabled=true] .Input_beforeInput_3XRl-X8Tip path:not([fill~=\"#\"]),.Input_inputContainer_2ifq9HK1IT[data-disabled=true] .Input_beforeInput_3XRl-X8Tip use:not([fill~=\"#\"]){fill:var(--neutral-dark,#a0a5ab)}.Input_input_2xGEVBSpyQ{flex:1;width:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;box-sizing:border-box;font-size:var(--font-spec-5-size,1rem);border:1px solid var(--neutral-light,#d5d9de);border-radius:var(--radius,3px);color:var(--foreground,#2d2d2d);background:var(--background,#fff);padding:8px;font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");display:flex;transition:border-color .2s ease-out;min-width:0}.Input_input_2xGEVBSpyQ.Input_hasBefore_1xkCMK-AkK{border-top-left-radius:0;border-bottom-left-radius:0;border-left:none}.Input_input_2xGEVBSpyQ.Input_hasAfter_3Zgk7Di0PJ{border-top-right-radius:0;border-bottom-right-radius:0;border-right:none}.Input_input_2xGEVBSpyQ.Input_hasFocus_1KUDRIxW17{box-shadow:0 0 0 4px var(--focus,rgba(96,150,230,.75))}.Input_input_2xGEVBSpyQ:focus{outline:none;border-color:var(--secondary-base,#0a7c8e)}.Input_input_2xGEVBSpyQ.Input_invalid_3dXOb-nrkb{border-color:var(--error-base,#d10f0f)}.Input_input_2xGEVBSpyQ:disabled{cursor:not-allowed;background:var(--neutral-light,#d5d9de);border-color:var(--neutral-light,#d5d9de);color:var(--neutral-dark,#a0a5ab)}.Input_input_2xGEVBSpyQ:disabled g:not([fill~=\"#\"]),.Input_input_2xGEVBSpyQ:disabled path:not([fill~=\"#\"]),.Input_input_2xGEVBSpyQ:disabled use:not([fill~=\"#\"]){fill:var(--neutral-dark,#a0a5ab)}";
var styles = {"inputContainer":"Input_inputContainer_2ifq9HK1IT","hasFocus":"Input_hasFocus_1KUDRIxW17","beforeInput":"Input_beforeInput_3XRl-X8Tip","afterInput":"Input_afterInput_21VUtLIisX","invalid":"Input_invalid_3dXOb-nrkb","input":"Input_input_2xGEVBSpyQ","hasBefore":"Input_hasBefore_1xkCMK-AkK","hasAfter":"Input_hasAfter_3Zgk7Di0PJ"};
styleInject(css_248z);

const Input = forwardRef((props, ref) => {
    const [hasFocus, setHasFocus] = React.useState(false);
    const { className = '', before, after, disabled, onBlur, onFocus, wrapperProps = {}, invalid } = props, rest = __rest(props, ["className", "before", "after", "disabled", "onBlur", "onFocus", "wrapperProps", "invalid"]);
    const containerClassNames = classnames({
        [styles.inputContainer]: true,
        [styles.beforeInput]: before,
        [styles.afterInput]: after,
        [styles.hasFocus]: hasFocus,
        [styles.invalid]: invalid,
        [wrapperProps.className]: wrapperProps.className || false,
    });
    const classNames = classnames({
        [styles.input]: true,
        [styles.hasBefore]: before,
        [styles.hasAfter]: after,
        [styles.invalid]: invalid,
        [styles.hasFocus]: hasFocus && !after && !before,
        [className]: className,
    });
    function handleFocus(e) {
        if (onFocus) {
            onFocus(e);
        }
        setHasFocus(true);
    }
    function handleBlur(e) {
        if (onBlur) {
            onBlur(e);
        }
        setHasFocus(false);
    }
    const input = (React.createElement("input", Object.assign({ className: classNames, disabled: disabled, ref: ref, onFocus: handleFocus, onBlur: handleBlur, "aria-invalid": invalid }, rest)));
    if (before || after) {
        return (React.createElement("div", Object.assign({ className: containerClassNames, "data-disabled": disabled }, wrapperProps),
            before && (React.createElement("span", { className: styles.beforeInput, "data-testid": "beforeInput" }, before)),
            input,
            after && (React.createElement("span", { className: styles.afterInput, "data-testid": "afterInput" }, after))));
    }
    return input;
});
Input.displayName = 'Input';

export { Input };
